import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";
import { useSession } from "../../Session";

function Analytics() {
  const { currentUser, config, mls } = useSession();
  const { pathname, search } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      ReactGA.initialize(config.googleAnalyticsCode);
      if (currentUser.name && mls.code) {
        ReactGA.set({
          dimension1: currentUser.name,
          dimension2: mls.code
        });
      }
      ReactGA.set({ location: window.location.href });
      ReactGA.pageview(pathname + search);
    });
  }, [pathname, search]);

  return null;
}

export default Analytics;
